<div class="container_dati-generali">
  <form #f="ngForm" [formGroup]="soggettoForm" (ngSubmit)="submit()">
    <div class="row">
      <div
        comboModInput
        class="col-sm-3"
        formControlName="tipoPersona"
        [labelInput]="'Tipo Persona'"
        [optionsCombo]="tipoPersonaOptions"
        [mandatory]="true"
        [control]="soggettoForm.controls['tipoPersona']"
        [labelOption]="'label'"
        [objectReference]="soggettoForm.get('tipoPersona').value"
        (onReturn)="soggettoForm.get('tipoPersona').setValue($event)"
      ></div>
      <div
        textInput
        [control]="soggettoForm.controls['nome']"
        class="col-sm-3"
        [labelInput]="'Nome'"
        [checkFormat]="true"
        [mandatory]="currentTipo == 'FISICA'"
        formControlName="nome"
      ></div>
      <div
        textInput
        [control]="soggettoForm.controls['cognome']"
        class="col-sm-3"
        [labelInput]="'Cognome'"
        [checkFormat]="true"
        [mandatory]="currentTipo == 'FISICA'"
        formControlName="cognome"
        [autocomplete]="'family-name'"
      ></div>
      <div
        *ngIf="editing"
        textInput
        [control]="soggettoForm.controls['nominativoOriginale']"
        class="col-sm-3"
        [labelInput]="'Nominativo originale'"
        [checkFormat]="true"
        formControlName="nominativoOriginale"
      ></div>
      <div
        *ngIf="!editing"
        textInput
        [control]="soggettoForm.controls['codiceFiscale']"
        class="col-sm-3"
        [checkFormat]="true"
        [mandatory]="currentTipo == 'FISICA'"
        [labelInput]="'Codice Fiscale'"
        formControlName="codiceFiscale"
      ></div>

    </div>

    <div class="row" *ngIf="editing">
      <div
        textInput
        [control]="soggettoForm.controls['codiceFiscale']"
        class="col-sm-3"
        [checkFormat]="true"
        [mandatory]="currentTipo == 'FISICA'"
        [labelInput]="'Codice Fiscale'"
        formControlName="codiceFiscale"
      ></div>
    </div>

    <div class="row">
      <div
        checkBoxRadio
        class="col-sm-2"
        [labelInput]="'Sesso'"
        idInput="Sesso"
        [labelChecked]="'M'"
        [labelNotChecked]="'F'"
        [mandatory]="currentTipo == 'FISICA' && !editing"
        [control]="soggettoForm.controls['sesso']"
        [objectReference]="soggettoForm.get('sesso').value"
        (onReturn)="soggettoForm.get('sesso').setValue($event)"
        [submitPending]="soggettoForm.get('sesso').disabled"
      ></div>
      <div
        checkBoxRadio
        class="col-sm-2"
        [labelInput]="'Dipendente'"
        idInput="dipendente"
        [control]="soggettoForm.controls['dipendente']"
        [objectReference]="soggettoForm.get('dipendente').value"
        (onReturn)="soggettoForm.get('dipendente').setValue($event)"
      ></div>
      <div
        textInput
        [control]="soggettoForm.controls['matricola']"
        class="col-sm-4"
        [mandatory]="false"
        [labelInput]="'Matricola'"
        [checkFormat]="true"
        formControlName="matricola"
        [submitPending]="soggettoForm.get('matricola').disabled"
      ></div>
      <div
        comboModInput
        class="col-sm-4"
        formControlName="societa"
        [labelInput]="'Società'"
        [optionsCombo]="societaOptions"
        [control]="soggettoForm.controls['societa']"
        [labelOption]="'nome'"
        [objectReference]="soggettoForm.get('societa').value"
        (onReturn)="soggettoForm.get('societa').setValue($event)"
      ></div>
    </div>

  <div class="row" *ngIf="currentTipo == 'FISICA' && isFascicoloSanitario()">
      <div
        checkBoxRadio
        class="col-sm-2"
        [labelInput]="'Vivente'"
        idInput="vivente"
        [control]="soggettoForm.controls['vivente']"
        [objectReference]="soggettoForm.get('vivente').value"
        (onReturn)="soggettoForm.get('vivente').setValue($event)"
      ></div>
    </div>

    <div class="row">
      <div
        textInput
        [control]="soggettoForm.controls['ragioneSociale']"
        class="col-sm-3"
        [mandatory]="currentTipo == 'GIURIDICA'"
        [labelInput]="'Ragione Sociale'"
        formControlName="ragioneSociale"
      ></div>
      <div
        textInput
        [control]="soggettoForm.controls['partitaIva']"
        class="col-sm-3"
        [checkFormat]="true"
        [mandatory]="currentTipo == 'GIURIDICA'"
        [labelInput]="'Partita IVA'"
        formControlName="partitaIva"
      ></div>
      <div
        textInput
        [control]="soggettoForm.controls['codiceFiscaleRappresentanteLegale']"
        class="col-sm-3"
        [checkFormat]="true"
        [labelInput]="'CF Rappresentante Legale'"
        formControlName="codiceFiscaleRappresentanteLegale"
      ></div>
      <div
        comboModInput
        class="col-sm-3"
        formControlName="tipoSocieta"
        [labelInput]="'Tipo Società'"
        [optionsCombo]="tipoSocietaOptions"
        [control]="soggettoForm.controls['tipoSocieta']"
        [labelOption]="'label'"
        [objectReference]="soggettoForm.get('tipoSocieta').value"
        (onReturn)="soggettoForm.get('tipoSocieta').setValue($event)"
      ></div>
    </div>

    <fieldset class="form-group form-group-info">
      <legend>Nascita <span class="sr-only">parte</span></legend>
      <div class="row row-form-group-info">
        <div
          datePickerInput
          class="col-sm-4"
          [control]="soggettoForm.get('dataNascita')"
          [labelInput]="'Data di nascita'"
          formControlName="dataNascita"
        ></div>
        <div
          comboModInput
          class="col-sm-4"
          formControlName="provinciaNascita"
          [labelInput]="'Provincia di nascita'"
          [optionsCombo]="provinciaOptions"
          [control]="soggettoForm.controls['provinciaNascita']"
          [labelOption]="'label'"
          [objectReference]="soggettoForm.get('provinciaNascita').value"
          (onReturn)="soggettoForm.get('provinciaNascita').setValue($event)"
        ></div>
        <div
          comboModInput
          class="col-sm-4"
          formControlName="comuneNascita"
          [labelInput]="'Comune di nascita'"
          [optionsCombo]="comuniNascitaOptions"
          [control]="soggettoForm.controls['comuneNascita']"
          [labelOption]="'label'"
          [objectReference]="soggettoForm.get('comuneNascita').value"
          (onReturn)="soggettoForm.get('comuneNascita').setValue($event)"
        ></div>
      </div>
    </fieldset>

    <fieldset class="form-group form-group-info">
      <legend>Residenza <span class="sr-only">parte</span></legend>
      <div class="row row-form-group-info">
        <div
          textInput
          [control]="soggettoForm.controls['indirizzo']"
          class="col-sm-12"
          [name]="'street-address'"
          [labelInput]="'Indirizzo di residenza'"
          formControlName="indirizzo"
        ></div>
      </div>

      <div class="row row-form-group-info">
        <div
          textInput
          [control]="soggettoForm.controls['cap']"
          class="col-sm-4"
          [checkFormat]="true"
          [labelInput]="'Inserire CAP'"
          formControlName="cap"
        ></div>
        <div
          comboModInput
          class="col-sm-4"
          formControlName="provinciaResidenza"
          [labelInput]="'Provincia di residenza'"
          [optionsCombo]="provinciaOptions"
          [control]="soggettoForm.controls['provinciaResidenza']"
          [labelOption]="'label'"
          [objectReference]="soggettoForm.get('provinciaResidenza').value"
          (onReturn)="soggettoForm.get('provinciaResidenza').setValue($event)"
        ></div>
        <div
          comboModInput
          class="col-sm-4"
          formControlName="comuneResidenza"
          [labelInput]="'Comune di residenza'"
          [optionsCombo]="comuniResidenzaOptions"
          [control]="soggettoForm.controls['comuneResidenza']"
          [labelOption]="'label'"
          [objectReference]="soggettoForm.get('comuneResidenza').value"
          (onReturn)="soggettoForm.get('comuneResidenza').setValue($event)"
        ></div>
      </div>
    </fieldset>

    <fieldset class="form-group form-group-info">
      <legend>Contatti <span class="sr-only">parte</span></legend>
      <div class="row row-form-group-info">
        <div
          textInput
          [control]="soggettoForm.controls['telefono']"
          class="col-sm-4"
          [checkFormat]="true"
          [labelInput]="'Telefono'"
          formControlName="telefono"
        ></div>
        <div
          textInput
          [control]="soggettoForm.controls['cellulare']"
          class="col-sm-4"
          [checkFormat]="true"
          [labelInput]="'Cellulare'"
          formControlName="cellulare"
        ></div>
        <div
          textInput
          [control]="soggettoForm.controls['fax']"
          class="col-sm-4"
          [checkFormat]="true"
          [labelInput]="'N Fax'"
          formControlName="fax"
        ></div>
      </div>

      <div class="row row-form-group-info">
        <div
          textInput
          [control]="soggettoForm.controls['email']"
          class="col-sm-6"
          [checkFormat]="true"
          [labelInput]="'Email'"
          formControlName="email"
          [autocomplete]="'email'"
        ></div>
        <div
          textInput
          [control]="soggettoForm.controls['pec']"
          class="col-sm-6"
          [checkFormat]="true"
          [labelInput]="'Pec'"
          formControlName="pec"
          [autocomplete]="'email'"
        ></div>
      </div>
    </fieldset>

    <div class="row">
      <div
        textAreaInput
        class="col-sm-12"
        [labelInput]="'Note'"
        formControlName="note"
      ></div>
    </div>

    <div class="row">
      <p class="mandatory col-sm-12">
        <em>* Campi obbligatori</em>
      </p>
    </div>

    <div class="row stepper-border-bottom-mb-15">
      <p class="col-sm-3 col-xs-6">
        <button
          type="button"
          class="btn btn-outline-secondary btn-block"
          (click)="createForm()"
        >
          Pulisci campi
        </button>
      </p>
      <p class="col-sm-3 col-xs-6 col-sm-offset-6">
        <button
          type="submit"
          class="btn btn-primary btn-block"
          [disabled]="!soggettoForm.valid"
        >
          {{ labelButton }}
        </button>
      </p>
    </div>
  </form>
</div>
